import { render } from "./NewsBookmark.vue?vue&type=template&id=e4e6b1ba&scoped=true"
import script from "./NewsBookmark.vue?vue&type=script&lang=js"
export * from "./NewsBookmark.vue?vue&type=script&lang=js"

import "./NewsBookmark.vue?vue&type=style&index=0&id=e4e6b1ba&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4e6b1ba"]])

export default __exports__